import styled from 'styled-components';

export const RadioGroup = styled.div`
    cursor: pointer;
`;
